'use client'

import { createContext, use, useCallback, useState, type ReactNode } from 'react'

type VideoCommentsPanelContextType = {
  isCommentPanelOpen: boolean
  toggleCommentPanel: () => void
  closeCommentPanel: () => void
  panelHostEl: HTMLDivElement | null
  setPanelHostEl: (el: HTMLDivElement | null) => void
}

const VideoCommentsPanelContext = createContext<VideoCommentsPanelContextType | null>(null)

export function VideoCommentsPanelProvider({ children }: { children: ReactNode }) {
  const [isCommentPanelOpen, setIsCommentPanelOpen] = useState(false)
  const [panelHostEl, setPanelHostEl] = useState<HTMLDivElement | null>(null)

  const toggleCommentPanel = useCallback(() => {
    setIsCommentPanelOpen((prev) => !prev)
  }, [])

  const closeCommentPanel = useCallback(() => {
    setIsCommentPanelOpen(false)
  }, [])

  return (
    <VideoCommentsPanelContext.Provider
      value={{
        isCommentPanelOpen,
        toggleCommentPanel,
        closeCommentPanel,
        panelHostEl,
        setPanelHostEl,
      }}
    >
      {children}
    </VideoCommentsPanelContext.Provider>
  )
}

export function useVideoCommentsPanelContext() {
  const ctx = use(VideoCommentsPanelContext)
  if (!ctx)
    throw new Error('useVideoCommentsPanelContext must be used within VideoCommentsPanelProvider')
  return ctx
}
